import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import { rem, rgba } from 'polished';
import Label from '../label';

const numberMask = createNumberMask({
  prefix: '$',
});

const DonateCustom = ({
  name,
  value,
  errors,
  id,
  placeholder,
  required,
  label,
  isDisabled,
  isDark,
  wrapStyles,
  ...rest
}) => (
  <DonateCustomWrap styles={wrapStyles}>
    <Label htmlFor={`${name}-custom`} hideLabel>{label}</Label>
    <DonateInput
      disabled={isDisabled}
      type="text"
      name={name}
      value={value}
      errors={errors}
      id={`${name}-custom`}
      placeholder={`${placeholder}${required ? '*' : ''}`}
      required={required}
      mask={numberMask}
      isdark={isDark.toString()}
      {...rest}
    />
    <DonateErrors>
      {errors}
    </DonateErrors>
  </DonateCustomWrap>
);

const DonateCustomWrap = styled.div`
  position: relative;
  line-height: 1;

  ${screen.below(bp.portrait, `
    grid-column: span 12;
  `)};

  ${props => props.styles && css`
    ${props.styles}
  `}
`;

const DonateInput = styled(MaskedInput)`
  font-size: inherit;
  font-family: inherit;
  color: ${props => props.isdark === 'true' ? '#808080' : '#fff'};
  height: 38px;
  padding: 0 16px 2px;
  border: 1px solid ${props => props.isdark === 'true' ? rgba(props.theme.blue, 0.4) : rgba('#fff', 0.2)};
  background-color: transparent;
  outline: none;
  appearance: none;
  border-radius: 0;

  &::placeholder {
    color: ${props => props.isdark === 'true' ? '#808080' : rgba(props.theme.blue, 0.6)};
  }

  &:focus {
    border-color: ${props => props.isdark === 'true' ? rgba(props.theme.blue, 0.6) : rgba('#fff', 0.5)};
  }

  ${props => props.value && css`
    border-color: ${props.theme.blue};
    background-color: ${props.theme.blue};
    color: #fff;
  `}

  ${screen.below(bp.mobileSm, `
    font-size: ${rem(16)};
  `)}
`;

const DonateErrors = styled.p`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  margin: 0;
  line-height: 1;
  font-size: .75rem;
  font-weight: 600;
  color: ${props => props.theme.error};
`;

DonateCustom.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  errors: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.string,
};

DonateCustom.defaultProps = {
  value: '',
};

export default DonateCustom;
